const isLocalHost = !!(
  location.hostname === "localhost" || location.hostname === "127.0.0.1"
);

const endpoint = isLocalHost
  ? "http://bankio.stage/backend"
  : "https://banking.artesiab.com/backend";

export default endpoint;
